import { client } from "./client";
import interceptors from "./interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getProduct(params) {
    return client.get("/tunnel/api/pos/convert-serial/product-to-convert", {
        params: params,
    });
}

function getListConvertSerial(params) {
    return client.get("/tunnel/api/pos/convert-serial/data", {
        params: params,
    });
}

function getWarehouse() {
    return client.get("/tunnel/api/pos/common/warehouse");
}

function dataSerial(params) {
    return client.get("tunnel/api/pos/transaction/serial", {
        params: params,
    });
}

function requestConvert(params) {
    return client.post("tunnel/api/pos/convert-serial/request-convert", qs.stringify(params), {
        header: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    });
}
export default {
    getListConvertSerial,
    getProduct,
    getWarehouse,
    dataSerial,
    requestConvert,
};